// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__QTQpG","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__d9J_q"};